import React from "react";

import styled from "styled-components";

import ManuscriptFilePanel from "components/organisms/manuscript/file/ManuscriptFilePanel";
import ManuscriptSearchPanel from "components/organisms/manuscript/search/ManuscriptSearchPanel";

const Panel = styled.section`
    display: flex;
    flex-direction: column;
    min-width: 0;
    min-height: 0;
    border-right: 1px solid #d3dde8;
    overflow: hidden;
    background: #f7fafc;

    @media (max-width: 1100px) {
        display: ${(props) => (props.$collapsed ? "none" : "flex")};
        position: fixed;
        top: 40px;
        left: 40px;
        bottom: 0;
        z-index: 70;
        width: min(360px, calc(100vw - 80px));
        border-right: 1px solid #c9d6e3;
        box-shadow: 16px 0 34px rgba(15, 23, 42, 0.16);
    }
`;

const Shell = styled.div`
    display: ${(props) => (props.$collapsed ? "none" : "flex")};
    flex-direction: column;
    min-width: 0;
    min-height: 0;
    width: 100%;
    height: 100%;
`;

function ManuscriptLeftPanel({
    activePanel,
    roots,
    expandedFolderIds,
    selectedNodeId,
    treeActionMenuNodeId,
    treeActionMenuRef,
    createNode,
    fileInputRef,
    uploadBinary,
    onOpenNode,
    onMoveNodeToParent,
    onTreeActionMenuOpen,
    searchQuery,
    setSearchQuery,
    onSearchSubmit,
    searchLoading,
    searchResults,
    onSearchResultSelect,
    outlineItems,
    outlineEnabled,
    activeOutlineLine,
    activeOutlineIds,
    onOutlineSelect,
    isCollapsed,
}) {
    return (
        <Panel $collapsed={isCollapsed}>
            <Shell $collapsed={isCollapsed}>
                {activePanel === "files" ? (
                    <ManuscriptFilePanel
                        roots={roots}
                        expandedFolderIds={expandedFolderIds}
                        selectedNodeId={selectedNodeId}
                        treeActionMenuNodeId={treeActionMenuNodeId}
                        treeActionMenuRef={treeActionMenuRef}
                        createNode={createNode}
                        fileInputRef={fileInputRef}
                        uploadBinary={uploadBinary}
                        onOpenNode={onOpenNode}
                        onMoveNodeToParent={onMoveNodeToParent}
                        onTreeActionMenuOpen={onTreeActionMenuOpen}
                        outlineItems={outlineItems}
                        outlineEnabled={outlineEnabled}
                        activeOutlineLine={activeOutlineLine}
                        activeOutlineIds={activeOutlineIds}
                        onOutlineSelect={onOutlineSelect}
                    />
                ) : null}

                {activePanel === "search" ? (
                    <ManuscriptSearchPanel
                        searchQuery={searchQuery}
                        setSearchQuery={setSearchQuery}
                        onSearchSubmit={onSearchSubmit}
                        searchLoading={searchLoading}
                        searchResults={searchResults}
                        onSearchResultSelect={onSearchResultSelect}
                    />
                ) : null}
            </Shell>
        </Panel>
    );
}

export default ManuscriptLeftPanel;
